import { render, staticRenderFns } from "./VehicleOwnershipType.vue?vue&type=template&id=247c1d9f&"
import script from "./VehicleOwnershipType.vue?vue&type=script&lang=js&"
export * from "./VehicleOwnershipType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports